"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationFilterTabs = NotificationFilterTabs;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_component_1 = require("../ui/button-component");
function NotificationFilterTabs(props) {
    var value = props.value, onChange = props.onChange, unreadCount = props.unreadCount;
    var tabs = [
        { value: "all", label: "All" },
        { value: "unread", label: unreadCount ? "Unread (".concat(unreadCount, ")") : "Unread" },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-2", children: tabs.map(function (tab) { return ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: tab.label, onPress: function () { return onChange(tab.value); }, variant: tab.value === value ? "primary" : "ghost", textSize: "small", textWeight: "bold" }, tab.value)); }) }));
}
